import React, { useState, useEffect } from 'react';
import './UrbanIADisclaimer.css';

const STORAGE_KEY = 'urbania_disclaimer_accepted';

const UrbanIADisclaimer = ({ userName, role, onAccept }) => {
  const [visible, setVisible] = useState(false);
  const normalizedRole = (role || 'user').toLowerCase();

  useEffect(() => {
    const accepted = localStorage.getItem(`${STORAGE_KEY}_${normalizedRole}`);
    if (!accepted) setVisible(true);
    else if (onAccept) onAccept();
  }, [normalizedRole]);

  const handleAccept = () => {
    localStorage.setItem(`${STORAGE_KEY}_${normalizedRole}`, 'true');
    setVisible(false);
    if (onAccept) onAccept();
  };

  if (!visible) return null;

  return (
    <div className="urbania-disclaimer-overlay">
      <div className="urbania-disclaimer-modal">
        <div className="urbania-disclaimer-header">
          <div className="urbania-disclaimer-avatar">🤖</div>
          <h2>Bienvenido a <span>UrbanIA</span></h2>
          <p className="urbania-disclaimer-sub">Tu asistente inteligente de UrbanQ</p>
        </div>

        <div className="urbania-disclaimer-body">
          <p className="urbania-disclaimer-welcome">
            ¡Hola, <strong>{userName}</strong>! UrbanIA es un asistente impulsado
            por <strong>Inteligencia Artificial</strong> diseñado para ayudarte
            a consultar información de tu condominio de forma rápida y sencilla.
          </p>

          <div className="urbania-disclaimer-features">
            <div className="urbania-disclaimer-feature">
              <span>💳</span>
              <p>{normalizedRole === 'admin' ? 'Consulta pagos, morosidad e ingresos de tu condominio' : 'Consulta tu saldo, deudas y pagos pendientes'}</p>
            </div>
            <div className="urbania-disclaimer-feature">
              <span>📢</span>
              <p>{normalizedRole === 'admin' ? 'Revisa avisos publicados y estadísticas de residentes' : 'Recibe avisos y comunicados del condominio'}</p>
            </div>
            <div className="urbania-disclaimer-feature">
              <span>⚡</span>
              <p>Respuestas en lenguaje natural, sin formularios complicados</p>
            </div>
          </div>

          <div className="urbania-disclaimer-box">
            <p className="urbania-disclaimer-title">⚠️ Aviso Importante</p>
            <p>UrbanIA utiliza un modelo de <strong>Inteligencia Artificial local</strong>.
            Las respuestas se basan en los datos reales de tu condominio, pero pueden
            contener imprecisiones. Para información crítica, consulta siempre con tu
            administrador directamente.</p>
            <p style={{marginTop:'8px'}}>
            UrbanIA <strong>no almacena</strong> tus conversaciones y procesa
            la información de forma privada dentro del sistema UrbanQ.
            </p>
          </div>
        </div>

        <div className="urbania-disclaimer-footer">
          <button className="urbania-disclaimer-btn" onClick={handleAccept}>
            Ingresar ✓
          </button>
        </div>
      </div>
    </div>
  );
};

export default UrbanIADisclaimer;
